import {AppThunk} from '../../index';
import data from './data';
import {sleep} from '../../../../shared/pipes/sleep';
import {ExpenseLiability} from '../../../../shared/models/socialSupport/expenseLiability';
import {expenseLiabilitiesSlice} from '../../../reducers/socialSupport/expenseLiabilities';

export const setExpenseLiabilities = expenseLiabilitiesSlice.actions.setExpenseLiabilities;

export const getExpenseLiabilities = (): AppThunk => {
  return async (dispatch) => {
    // const response = await httpService.get<ExpenseLiability[]>(getApiRoute(urls.getExpenseLiabilities));
    await sleep(10);
    const response = data as ExpenseLiability[]; // ToDo: заменить на вызов api когда будет доступен
    dispatch(setExpenseLiabilities(response));
  };
};
